---
import type { Props as PortableTextProps } from 'astro-portabletext/types';
import EmbedVideo from '../ui/EmbedVideo';

type Props = PortableTextProps<{ url: string; _type: string }>;

const { node } = Astro.props;
---

<EmbedVideo url={node.url} client:only="react" />
